import { render, staticRenderFns } from "./OrderWater.vue?vue&type=template&id=2508acc9&"
import script from "./OrderWater.vue?vue&type=script&lang=js&"
export * from "./OrderWater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports